import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]

import { computed } from 'vue';

interface Props {
	rating: string;
	theme?: 'bold' | 'normal';
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RatingBox',
  props: {
    rating: {},
    theme: { default: 'bold' }
  },
  setup(__props: any) {



const blockClassModifiers = computed(() => ({
	[`rating-box-badge--${__props.theme}`]: true,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['rating-box-badge', blockClassModifiers.value]),
    textContent: _toDisplayString(_ctx.rating)
  }, null, 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})